const equifaxPersonalized = require('../../mock/creditEquifaxPersonalized.json');

export default {
  answerQuestions: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({ data: equifaxPersonalized });
      }, 1000);
    }),
};
